import { PropsWithChildren } from 'react';
import { DurationVitalGate, DurationVitalProvider, ReportDurationVital } from './durationVital';

export const APPLICATION_SUBMIT_TO_DECISION_VITAL = 'application.submit_to_decision';

interface ApplicationSubmitToDecisionProviderProps extends PropsWithChildren {
    context?: Record<string, unknown>;
}

export const ApplicationSubmitToDecisionProvider = ({
    context,
    children,
}: ApplicationSubmitToDecisionProviderProps) => (
    <DurationVitalProvider vitalName={APPLICATION_SUBMIT_TO_DECISION_VITAL} context={context}>
        {children}
    </DurationVitalProvider>
);

export const ReportApplicationSubmitToDecision = ReportDurationVital;

/** Place around terminal decision UI so the vital excludes reviewing/spinner states. */
export const ApplicationSubmitToDecisionGate = ({ children }: PropsWithChildren) => (
    <DurationVitalGate>{children}</DurationVitalGate>
);
